<section class="course-dashboard">
  <!-- Stats row -->
  <div class="stats-row">
    <!-- Course progress -->
    <div class="stat-card stat-progress">
      <div class="progress-ring-wrapper">
        <mat-progress-spinner
          mode="determinate"
          [diameter]="72"
          [strokeWidth]="7"
          [value]="course.progressPercent"
        ></mat-progress-spinner>
        <span class="progress-ring-label">{{ course.progressPercent }}%</span>
      </div>
      <div class="stat-info">
        <span class="stat-label">Course Progress</span>
        <span class="stat-sub">{{ course.title }}</span>
      </div>
    </div>

    <!-- Sessions -->
    <div class="stat-card">
      <mat-icon class="stat-icon">event_available</mat-icon>
      <div class="stat-info">
        <span class="stat-value">{{ course.completedSessions }} / {{ course.totalSessions }}</span>
        <span class="stat-label">Sessions Completed</span>
      </div>
    </div>

    <!-- Quizzes -->
    <div class="stat-card">
      <mat-icon class="stat-icon">quiz</mat-icon>
      <div class="stat-info">
        <span class="stat-value">{{ course.quizResults.length }}</span>
        <span class="stat-label">Quizzes Taken</span>
      </div>
    </div>

    <!-- Quiz average -->
    <div class="stat-card">
      <mat-icon class="stat-icon">grade</mat-icon>
      <div class="stat-info">
        <span class="stat-value">{{ course.quizAverage > 0 ? course.quizAverage + '%' : '—' }}</span>
        <span class="stat-label">Quiz Average</span>
      </div>
    </div>
  </div>

  <div class="calendar-and-next">
    <!-- Calendar -->
    <div class="calendar-card">
      <div class="calendar-header">
        <button mat-icon-button (click)="prevMonth()"><mat-icon>chevron_left</mat-icon></button>
        <span class="calendar-month">{{ currentMonth | date: 'MMMM yyyy' }}</span>
        <button mat-icon-button (click)="nextMonth()"><mat-icon>chevron_right</mat-icon></button>
      </div>

      <div class="calendar-grid">
        @for (wd of weekDays; track wd) {
          <span class="calendar-weekday">{{ wd }}</span>
        }
        @for (day of calendarDays; track day.date) {
          <div
            class="calendar-day"
            [class.has-session]="day.session"
            [class.other-month]="!day.isCurrentMonth"
            [class.session-done]="day.session?.completed"
            [class.today]="day.isToday"
            [matTooltip]="day.session ? 'Session ' + day.session.moduleNumber + ': ' + day.session.title : ''"
          >
            <span>{{ day.dayNumber }}</span>
            <span class="session-marker" *ngIf="day.session"></span>
          </div>
        }
      </div>
    </div>

    <!-- Next session reminder -->
    <div class="next-session-card" *ngIf="course.nextSession">
      <div class="next-session-icon">
        <mat-icon>notifications_active</mat-icon>
      </div>
      <div class="next-session-info">
        <span class="next-label">Next Session</span>
        <span class="next-title"> Session {{ course.nextSession.moduleNumber }}: {{ course.nextSession.title }} </span>
        <span class="next-date">
          {{ course.nextSession.date | date: 'EEEE, MMM d' }}
          @if (daysUntilNextSession !== null) {
            @if (daysUntilNextSession === 0) {
              <span class="next-badge today-badge">Today!</span>
            } @else if (daysUntilNextSession === 1) {
              <span class="next-badge">Tomorrow</span>
            } @else {
              <span class="next-badge">in {{ daysUntilNextSession }} days</span>
            }
          }
        </span>
      </div>
    </div>
  </div>
</section>
